<i18n>
{
  "en": {
    "optimizerDataError": "Error loading optimizer data",
    "missingPeriods": "No optimizer options for this point of sale"
  },
  "es": {
    "missingPeriods": "No hay opciones de optimización para este periodo",
    "optimizerDataError": "Error cargando datos del optimizador"
  }
}
</i18n>
<template>
  <router-view/>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { MapActions, MapGetters } from '@core/helpers/decorators';
import { Watch } from 'vue-property-decorator';
import { createErrorNotification } from '@ulibs/unnotificationsqueue';
import VueRouter from 'vue-router';

const { isNavigationFailure, NavigationFailureType } = VueRouter;
@Component
@MapGetters(['isLoading', 'predictionPeriodList', 'nextPeriod'])
@MapActions(['setLoading', 'pointOfSaleSettingsRequest',
  'addNotification', 'boostedProductListRequest'])
export default class Optimizer extends Vue {
  async created() {
    this.$root.$on('changedLanguage', this.onChangedLanguage);
    await this.loadBoostedProducts();
  }

  beforeDestroy() {
    this.$root.$off('changedLanguage');
  }

  async loadBoostedProducts() {
    try {
      const { periodGuid } = this.$route.params;
      if (periodGuid) await this.boostedProductListRequest({ periodGuid });
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('boostedProductsError'), null));
    }
  }

  @Watch('$route.params.pointOfSaleGuid')
  async onPosGuidChanged(newVal, oldVal) {
    if (newVal !== oldVal) {
      await this.loadBoostedProducts();
    }
  }

  @Watch('predictionPeriodList')
  async onPredictionPeriodList() {
    if (!this.predictionPeriodList.cleared) {
      // Go out on empty period list
      if (this.predictionPeriodList.length === 0) {
        await this.$router.push({
          name: 'restaurant-management',
        }).catch((e) => {
          if (!isNavigationFailure(e, NavigationFailureType.aborted)) {
            Promise.reject(e);
          }
        });
        // Go to correct periodGuid
      } else if (!this.predictionPeriodList.find((period) => period.guid === this.$route.params.periodGuid)) {
        await this.$router.push({
          name: 'optimizer',
          params: {
            periodGuid: this.nextPeriod.guid
          }
        }).catch((e) => {
          if (!isNavigationFailure(e, NavigationFailureType.aborted)) {
            Promise.reject(e);
          }
        });
      }
    }
  }
}
</script>
